"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESOLVE_APPROVAL_CHAIN_RESPONSE_EXAMPLE = void 0;
exports.RESOLVE_APPROVAL_CHAIN_RESPONSE_EXAMPLE = [
    { sequence: 1, roleId: '10101010-1010-1010-1010-101010101010', isMandatory: true },
    { sequence: 2, roleId: '20202020-2020-2020-2020-202020202020', isMandatory: false },
];
//# sourceMappingURL=financial-approval.response.js.map